import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-around" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShiftToText = _resolveComponent("ShiftToText")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.order?.shift?.name), 1),
      _createVNode(_component_ShiftToText, {
        shift: _ctx.order.shift
      }, null, 8, ["shift"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.order.pickup_priority)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("span", null, [
              _hoisted_3,
              _createVNode(_component_DateFormatted, {
                date: _ctx.order.pickup_datetime,
                format: "HH:mm"
              }, null, 8, ["date"])
            ], 512), [
              [
                _directive_tooltip,
                'Ritiro urgente',
                void 0,
                { bottom: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order.dropoff_priority)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _withDirectives(_createElementVNode("span", null, [
              _hoisted_5,
              _createVNode(_component_DateFormatted, {
                date: _ctx.order.dropoff_datetime,
                format: "HH:mm"
              }, null, 8, ["date"])
            ], 512), [
              [
                _directive_tooltip,
                'Consegna urgente',
                void 0,
                { bottom: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}